const showDrawer = (state = false, action)=>{
    if(action.type === "SET_SHOW_DRAWER"){
        state = action.state
    }

    return state;
}

export default showDrawer;